var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7488_113127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.001 0.00012207C35.8166 0.00012207 0.000976562 35.8158 0.000976562 80.0001C0.000976562 124.185 35.8166 160 80.001 160C124.185 160 160.001 124.181 160.001 80.0001C160.001 35.8195 124.185 0.00012207 80.001 0.00012207Z",
    fill: "#00A0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.818 127.511C144.309 119.635 149.216 110.405 152.061 100.309H127.53L137.822 127.511H137.818Z",
    fill: "#000F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2705 100.312L61.2197 152.358C67.2517 153.927 73.5772 154.762 80.0984 154.762C89.6148 154.762 98.7136 152.978 107.082 149.739L93.7804 100.312H75.2705Z",
    fill: "#000F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3281 100.312L112.058 147.601C120.227 143.733 127.58 138.427 133.797 132.011L121.804 100.312H99.3281Z",
    fill: "#000F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4256 100.312L33.0889 138.134C39.8734 143.628 47.6364 147.959 56.0804 150.822L69.7173 100.312H47.4219H47.4256Z",
    fill: "#000F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.095 5.24182C38.8043 5.24182 5.33301 38.7131 5.33301 80.0038C5.33301 85.3434 5.89745 90.5475 6.9586 95.5711H153.228C154.289 90.5475 154.853 85.3434 154.853 80.0038C154.853 38.7131 121.382 5.24182 80.0912 5.24182",
    fill: "#000F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12486 100.312C11.8426 113.509 19.0901 125.223 28.7834 134.374L41.6902 100.312H8.12109H8.12486Z",
    fill: "#000F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 84.2824H26.4174C34.44 84.2824 37.281 82.0773 37.281 75.4131C37.281 70.4574 33.868 68.0604 28.2123 67.2175L24.7128 66.4912C24.9348 66.5213 24.4682 66.4536 24.7128 66.4912C22.8539 66.2429 21.424 64.7715 21.4541 63.2212C21.5331 59.4131 25.2848 59.4131 26.9217 59.4131H36.472V55.097H27.1136C22.4513 55.097 16.3666 56.0002 16.25 63.8007C16.1785 68.6361 20.1108 70.9616 24.2989 71.5787L25.9245 71.9211C28.1709 72.2636 32.0769 73.1742 32.0769 76.1845C32.0769 80.1206 27.7232 79.9663 26.2933 79.9663H16.25V84.2824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.77 84.4441H66.9779V65.2794C66.9779 58.5061 63.2864 55.2399 58.2027 55.0743H44.6787V84.4441H49.8866V59.5447H55.9224C58.9101 59.477 61.77 60.4177 61.77 66.2804V84.4478V84.4441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9125 55.0744H76.2493V59.8759H84.5202C89.4797 59.6727 90.8081 61.9192 90.8081 65.9455V67.4093H83.4402C76.8965 67.4093 73.7168 70.7056 73.7168 76.2296C73.7168 81.7536 77.2314 84.3049 82.1119 84.4441H96.016V65.9455C96.016 56.8091 91.3537 55.0029 85.9125 55.0744ZM90.7629 79.9512H83.3725C80.3622 80.0114 79.0639 78.3331 79.0639 76.0942C79.0639 73.6896 80.0348 71.4808 84.7798 71.6125H90.7629V79.9512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.625 55.0743H122.255H118.417C118.417 55.0743 118.41 55.0743 118.406 55.0743H105.036V84.4441H110.184V59.5447H116.152C116.34 59.5409 116.528 59.5409 116.713 59.5447H122.06V66.2804V84.4478H127.29V59.5485H133.371C136.325 59.4807 139.151 60.4215 139.151 66.2841V84.4516H144.299V65.2869C144.299 58.5137 140.649 55.2474 135.621 55.0819",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7488_113127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bdb1e97192ddbd3a86ed5cb02c7e8038.svg";
export { ForwardRef as ReactComponent };